import { Injectable } from '@angular/core';
import { ApiService, RepositoryImpl } from '@homeleite/arch';
import { Animal, AnimalSummary } from './animal';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AnimalsApiRepository extends RepositoryImpl<AnimalSummary, Animal> {
    constructor(api: ApiService) {
        super(api.root.path('/animals'), AnimalSummary, Animal);
    }

    public updateActiveState(animalId: string, newActiveState: boolean): Observable<AnimalSummary> {
        return this.api
            .path(animalId)
            .patchJson<AnimalSummary>({
                isActive: newActiveState
            });
    }
}
